import React from "react";
import { useChat } from "../hooks/useChat";
import ChatPanel from "./ChatPanel";

const CHAT_ENABLED = process.env.REACT_APP_ENABLE_CHAT === "true";

/**
 * Floating chat FAB + panel for authenticated layouts (User/Admin).
 * Public pages use the embedded column in PublicLayout instead.
 */
const ChatButton: React.FC = () => {
  const {
    messages,
    isStreaming,
    isOpen,
    setIsOpen,
    sendMessage,
    stopStreaming,
    clearMessages,
  } = useChat();

  if (!CHAT_ENABLED) return null;

  return (
    <>
      {isOpen && (
        <ChatPanel
          messages={messages}
          isStreaming={isStreaming}
          onSend={sendMessage}
          onStop={stopStreaming}
          onClose={() => setIsOpen(false)}
          onClear={clearMessages}
        />
      )}

      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`fixed bottom-4 right-4 z-50 h-12 w-12 rounded-full shadow-lg flex items-center justify-center transition-all duration-200 ${
          isOpen
            ? "bg-surface-600 text-text-primary hover:bg-surface-500"
            : "bg-quantum-500 text-white hover:bg-quantum-600"
        }`}
        title="TotalView Assistant"
      >
        {isOpen ? (
          <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        ) : (
          <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
          </svg>
        )}

        {/* Notification dot when streaming */}
        {isStreaming && !isOpen && (
          <span className="absolute -top-0.5 -right-0.5 h-3 w-3 rounded-full bg-green-400 animate-pulse" />
        )}
      </button>
    </>
  );
};

export default ChatButton;
